import { useStaticQuery, graphql } from 'gatsby'

export default function useGetHomepageContent() {
    const data = useStaticQuery(graphql`
        query HomepageQuery {
            homepage {
                id
                brand_id
                sale_bar
                banner
                featured_products
                hero_title
                hero_products
                sale_products
                collection_products
                trending_offer
                trending_offer_title
                browser_category_desc
                browser_category_title
                subscribe_save
                unlock_products
            }
        }
    `)
    return data.homepage
}
